import { IntlProvider } from 'react-intl';
import { FormStoreDatasProvider } from '../store/useFormStoreDatas';
import type { ReactNode } from 'react';

export const Provider = ({ children }: { children: ReactNode }) => {
  return (
    <IntlProvider locale="fr" timeZone="UTC" defaultLocale="fr" onError={() => undefined}>
      <FormStoreDatasProvider>{children}</FormStoreDatasProvider>
    </IntlProvider>
  );
};
